import { Box, Tab, Tabs } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUserPermissions } from 'shared/hooks';
import UseDynamicUrl from 'shared/hooks/useDynamicUrl';

type UseCurrentTabProps = {
    orderedTabList: string[];
};

const useCurrentTab = ({ orderedTabList }: UseCurrentTabProps) => {
    const { pathname } = useLocation();

    let index = 0;
    const lastTabIndex = orderedTabList.length - 1;

    for (const tab of orderedTabList) {
        if (index === lastTabIndex || pathname.includes(tab)) return tab;
        index++;
    }
};

const ADD_DEVIATIONS = 'addDeviations';
const MANAGE_PRICING = 'managePricing';
const ADD_PRODUCTS = 'addProducts';
const DISTRIBUTOR_MANAGEMENT = 'distributorManagement';
const TIER_SETUP = 'tierSetUp';

export function CurrentPricesActions() {
    const { isAddProductAllowed } = useUserPermissions();

    const currentTab = useCurrentTab({
        orderedTabList: [ADD_PRODUCTS, ADD_DEVIATIONS, TIER_SETUP, MANAGE_PRICING, DISTRIBUTOR_MANAGEMENT],
    });
    const [activeTab, setActiveTab] = useState(currentTab);

    const tabChange = useCallback((event, value: string) => {
        setActiveTab(value);
    }, []);

    const managePricing = UseDynamicUrl({ route: ROUTES.managePricing });
    const addDeviations = UseDynamicUrl({ route: ROUTES.addDeviationsCatalog });
    const addProducts = UseDynamicUrl({ route: ROUTES.addProductsCatalog });
    const tierSetup = UseDynamicUrl({ route: ROUTES.tierSetUp });

    useEffect(() => {
        if (activeTab !== currentTab) {
            setActiveTab(currentTab);
        }
    }, [activeTab, currentTab]);

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={tabChange}
                    textColor='secondary'
                    indicatorColor='secondary'
                    aria-label='customer details'
                >
                    <Tab
                        value={MANAGE_PRICING}
                        label='Manage Prices'
                        component={ReactRouterLink}
                        to={managePricing.path}
                    />
                    <Tab
                        value={ADD_DEVIATIONS}
                        label='Add Deviations'
                        component={ReactRouterLink}
                        to={addDeviations.path}
                    />
                    {isAddProductAllowed && (
                        <Tab
                            value={ADD_PRODUCTS}
                            label='Add Products'
                            component={ReactRouterLink}
                            to={addProducts.path}
                        />
                    )}
                    (
                    <Tab
                        value={TIER_SETUP}
                        label='Customer Tier Setup'
                        component={ReactRouterLink}
                        to={tierSetup.path}
                    />
                    )
                </Tabs>
            </Box>
        </>
    );
}
